import { Association } from '../../../shared/models/association.model';
import { AssociationService } from '../../../shared/services/association.service';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

@Component({
  selector: 'app-association-cerfa-download',
  templateUrl: './association-cerfa-download.component.html',
  styleUrls: ['./association-cerfa-download.component.css']
})
export class AssociationCerfaDownloadComponent implements OnInit {

  modalTitle = 'Cerfa Export';
  associations: Association[];
  assocCerfaExport: FormGroup;
  error: Error;

  constructor(public activeModal: NgbActiveModal, private service: AssociationService, private formbuilder: FormBuilder) {
    this.assocCerfaExport = this.formbuilder.group({
      'date_from': ['', Validators.required],
      'date_to': ['', Validators.required],
      'assocs': ['', Validators.required]
    });

    this.service.list().subscribe(data => {
      this.associations = data;
    });
  }

  ngOnInit() {
  }

  onSubmit() {
    this.validateAllFormFields(this.assocCerfaExport);
    this.checkIfStartDateLessThanToDate('date_from', 'date_to');
    console.log('Date from', moment(this.assocCerfaExport.value['date_from']).local().startOf('day').format());
    console.log('Date to', moment(this.assocCerfaExport.value['date_to']).local().endOf('day').format());


    if (this.assocCerfaExport.valid) {
      const params = {
        'assocs': this.assocCerfaExport.value['assocs'],
        'dateFrom': moment(this.assocCerfaExport.value['date_from']).local().startOf('day').format(),
        'dateTo': moment(this.assocCerfaExport.value['date_to']).local().endOf('day').format()
      };
      this.downloadFile(params);
    }
  }

  downloadFile(params: any)  {
    this.service.downloadCerfa(params).subscribe(
      (data) => {
        const blob = new Blob([data.body], {type: 'application/zip'});
        saveAs(blob, 'cerfa.zip');
        this.activeModal.close('download-success');
      },
      (error) => {
        this.activeModal.close('download-error');
        console.log('ERROR', error);
      },
      () =>  {
        console.log('downloadFile : Request Complete')
      }
    );
  }

  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private checkIfStartDateLessThanToDate(fromDateKey: string, toDateKey: string) {
    const from = this.assocCerfaExport.controls[fromDateKey];
    const to = this.assocCerfaExport.controls[toDateKey];

    if (from.value > to.value) {
      from.setErrors({ greater: true });
    } else if (from.value === "") {
      from.setErrors({ invalid: true });
    } else if (from.value == null) {
      from.setErrors({ invalid: true });
    } else if (from.value == 'Invalid Date') {
      from.setErrors({ invalid: true });
    } else {
      from.setErrors(null);
    }
  }
}
